module.exports = __webpack_public_path__ + "media/src/site/images/logout-e497f101bf0392eef26615aa9e142aff.svg";